import React, { useEffect, useState } from 'react';
import { Button, Card, Divider } from 'antd';
import { Link } from 'react-router-dom';

import UserStore from '../stores/UserStore';
import UIStore from '../stores/UIStore';
import { CheckCircleOutlined } from '@ant-design/icons';

const Verify = () => {
    const [sendToCustomer, setSendToCustomer] = useState<boolean>(false);

    const handleSendingEmail = () => {
        setSendToCustomer(true);
        UserStore.resend();
    };

    useEffect(() => {
        UIStore.setDocumentTitle('Verify');
    }, []);

    useEffect(() => {
        UserStore.pullUser();
    }, []);

    let text: React.ReactNode | null = null;

    if (sendToCustomer) {
        text = (
            <div>
                <div>
                    <CheckCircleOutlined
                        style={{
                            color: 'green',
                            fontSize: 40,
                        }}
                    />
                </div>
                <div className={'mt-2'}>
                    A verification link has been sent to <strong>{UserStore?.user?.email}</strong> .
                </div>
            </div>
        );
    } else {
        text = (
            <div>
                <p className="mb-2">
                    We have sent a Verification Email to <strong>{UserStore.user?.email}</strong>, please verify before
                    continuing to your Account.
                </p>
                <Button type="primary" onClick={handleSendingEmail}>
                    Resend Verification Email
                </Button>
                <Divider> or </Divider>
                <p className="mb-2">Do you have a different email address?</p>
                <Link to={'/my-account/settings/emails'}>
                    <Button>Add here</Button>
                </Link>
            </div>
        );
    }
    return (
        <div className="container py-4">
            <Card className="verify-card text-center mr-auto ml-auto">{text}</Card>
        </div>
    );
};

export default Verify;
